import config from '@/config';
import { DeviceType } from '@/logic/main/types';
import { fetchData } from '@/model/utils/fetch';
import { PortalVerticalGameTilePropTypes } from '@/types/gameTypes';
import { getLocale } from '@/utils';

import { createGameLaunchModel } from './gameLaunch';

export const gameLaunchModel = createGameLaunchModel();

export const fetchGame = async ({
  locale,
  viewer_country,
  viewer_region,
  game_code,
}: {
  locale?: string;
  viewer_country?: string;
  viewer_region?: string;
  game_code: string;
}): Promise<
  | { result: 'success'; game: PortalVerticalGameTilePropTypes }
  | { result: 'failure'; error: { status: number } }
> => {
  try {
    const res = await fetchData<{ data: PortalVerticalGameTilePropTypes }>({
      url: `${config.urls.bffBaseUrl}/game/${game_code}`,
      queryParameters: {
        locale,
        market_country: viewer_country,
        market_region: viewer_region,
      },
    });

    return {
      result: 'success',
      game: res.data,
    };
  } catch (err) {
    console.error(
      `There was a problem while fetching game. ${config.urls.bffBaseUrl}/game`
    );
    console.error(err);

    return {
      result: 'failure',
      error: err as any,
    };
  }
};

export const fetchGamesByProvider = async ({
  deviceType,
  provider,
  limit,
  skip,
}: {
  provider: string;
  deviceType: DeviceType;
  skip: number;
  limit: number;
}) => {
  try {
    const queryParamsMap = {
      market_country: config.viewer_country,
      market_region: config.viewer_region,
      locale: getLocale(config),
      device_type: deviceType,
      base_path: config.base_path,
      provider,
      skip,
      limit,
    };
    const queryParams = Object.entries(queryParamsMap)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');

    const response = await fetchData<{
      games: PortalVerticalGameTilePropTypes[];
      count: number;
    }>({
      url: `${config.urls.bffBaseUrl}/filtered-games/provider?${queryParams}`,
    });

    return {
      result: 'success' as const,
      games: response.games,
      count: response.count,
    };
  } catch (err) {
    console.error(
      `There was a problem while fetching games. ${config.urls.bffBaseUrl}/filtered-games`
    );
    console.error(err);

    return {
      result: 'failure' as const,
      error: err as any,
    };
  }
};
